import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../Common/Icon';
import MultiSelectBox from '../../Common/MultiSelectBox/MultiSelectBox';
import Toggle from '../../Common/Toggle/Toggle';
import {
    DailyDigestPopover,
    WeeklyDigestPopover
} from '../../../constants/constants';

// From Dan Abramov himself: https://github.com/facebook/create-react-app/issues/679#issuecomment-266209431
import $ from 'jquery';
window.jQuery = $;
require('bootstrap');

export class EmailNotificationsForm extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.dailyRef = React.createRef();
        this.weeklyRef = React.createRef();
    }

    componentDidMount() {
        $(this.dailyRef.current).popover();
        $(this.weeklyRef.current).popover();
    }

    onToggleChange = (name, value) => {
        this.props.onFormChange(name, value);
    }

    onMultiSelectChange = (value, name) => {
        this.props.onFormChange(name, value.toString());
    }

    onSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();

        this.props.onContinue();
    }

    render() {
        const valid = this.props.isFormValid ? "" : "was-validated";
        const className = "email-notification-form " + valid;
        const msg = "Would you like to receive Daily or Weekly email notifications for the new subscription?";

        return (
            <form onSubmit={this.onSubmit} className={className} noValidate>
                <div>{msg}</div>
                <br />
                <div className="row toggle-wrapper">
                    <Toggle name="sendDailyEmail" text="Daily Digest" checked={this.props.userRequest.sendDailyEmail} onChange={this.onToggleChange} />
                    <div ref={this.dailyRef}
                        data-toggle="popover"
                        title={DailyDigestPopover.Title}
                        data-placement="bottom"
                        data-content={DailyDigestPopover.Body}
                    >
                        <Icon name="info-circle" />
                    </div>
                </div>

                {
                    this.props.userRequest.sendDailyEmail
                        ?
                        <MultiSelectBox name="hourOfDayId" label="Send daily notifications around this time of day" idField="id" valueField="name"
                            options={this.props.hoursOfTheDay}
                            selectedValues={this.props.userRequest.hourOfDayId.toString()}
                            onChange={this.onMultiSelectChange}
                            isRequired={this.props.userRequest.sendDailyEmail}
                            errorMessage="An hour must be selected"
                            isMulti={false}
                        />
                        :
                        null
                }

                <div className="row toggle-wrapper">
                    <Toggle name="sendWeeklyEmail" text="Weekly Digest" checked={this.props.userRequest.sendWeeklyEmail} onChange={this.onToggleChange} />
                    <div ref={this.weeklyRef}
                        data-toggle="popover"
                        title={WeeklyDigestPopover.Title}
                        data-placement="bottom"
                        data-content={WeeklyDigestPopover.Body}
                    >
                        <Icon name="info-circle" />
                    </div>
                </div>

                {
                    this.props.userRequest.sendWeeklyEmail
                        ?
                        <MultiSelectBox name="dayOfWeekId" label="Send Weekly notifications on this day" idField="id" valueField="name"
                            options={this.props.daysOfTheWeek}
                            selectedValues={this.props.userRequest.dayOfWeekId.toString()}
                            onChange={this.onMultiSelectChange}
                            isRequired={this.props.userRequest.sendWeeklyEmail}
                            errorMessage="A day must be selected"
                            isMulti={false}
                        />
                        :
                        null
                }
            </form>
        );
    }
}

EmailNotificationsForm.propTypes = {
    userRequest: PropTypes.object.isRequired,
    onContinue: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onFormChange: PropTypes.func.isRequired,
    isFormValid: PropTypes.bool.isRequired,
    hoursOfTheDay: PropTypes.array.isRequired,
    daysOfTheWeek: PropTypes.array.isRequired
};

export default EmailNotificationsForm;
